import axios from '../axios';
import { endPoints } from '../endpoints';
import {
  SnoozeResponse,
  UrgentActionsResponse,
  UrgentActionsSummaryResponse,
} from '@nxsys/types/api/urgentActions';

export const getUrgentActionsSummaryApi =
  async (): Promise<UrgentActionsSummaryResponse> => {
    const response = await axios.get(endPoints.urgentActions.summary);
    return response.data;
  };

export const getUrgentActionsApi =
  async (): Promise<UrgentActionsResponse> => {
    const response = await axios.get(endPoints.urgentActions.main);
    return response.data;
  };

export const snoozeUrgentActionApi = async (): Promise<SnoozeResponse> => {
  const response = await axios.post(endPoints.urgentActions.snooze);
  return response.data;
};
